import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  UsersWithWalletParams,
  UsersWithWalletResponse,
  WalletApiService,
} from 'features/wallet';

import { walletQueryKeys } from './query-keys';

const { getUsersWithWallet } = WalletApiService();

const getUsersWithWalletQuery = (
  params: UsersWithWalletParams,
  options?: UseQueryOptions<UsersWithWalletResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<UsersWithWalletResponse>;
  options?: UseQueryOptions<UsersWithWalletResponse>;
} => ({
  queryKey: walletQueryKeys.list(params),
  queryFn: ({ signal }) => getUsersWithWallet(params, { config: { signal } }),
  ...options,
});

export const useGetUsersWithWallet = (
  params: UsersWithWalletParams,
  options?: UseQueryOptions<UsersWithWalletResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<UsersWithWalletResponse, Error>(
    getUsersWithWalletQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
